import '~/assets/dev/styles.scss';

jQuery(document).ready(function($) {


	// Focus styles for menus when using keyboard navigation
	// Properly update the ARIA states on focus (keyboard) and mouse over events
	$( '[role="menubar"]' ).on( 'focus.aria mouseenter.aria', '[aria-haspopup="true"]', function ( ev ) {
		$( ev.currentTarget ).attr( 'aria-expanded', true );
	});
	// Properly update the ARIA states on blur (keyboard) and mouse out events
	$( '[role="menubar"]' ).on( 'blur.aria mouseleave.aria', '[aria-haspopup="true"]', function ( ev ) {
		$( ev.currentTarget ).attr( 'aria-expanded', false );
	});

	// position mega menu
	$('li.mega-menu').hover(function(){

	}, function(){
		
	});

	// inview js
	let initInview = function() {
		$('.on-inview').each(function() {
			let target = $(this);
			target.on('inview', function(event, isInView) {
				if(isInView) {
					$(this).addClass('slide-top');
				} 
			})
		});
	}

	// news slider for mobile
	let initNewsSlider = function() {
		$('.news-grid-slider').slick({
			infinite: true,
	  		slidesToShow: 2,
	  		slidesToScroll: 2,
	  		centerMode: true,
	  		dots: false,
	  		responsive: [
			    {
			      breakpoint: 1024,
			      settings: {
			        slidesToShow: 1,
			        slidesToScroll: 1,
			      }
			    },
			  ]
		});
	}
	initNewsSlider();

	// mobile nav
    let initMobileNav = function() {
    	$('.mobile-nav-toggle').on('click', function() {
    		let toggle = $(this);
    		let mobileNav = $('#mobile-nav-wrapper');
    		let headerHeight = $('#masthead').height();
    		let windowHeight = $(window).height();
    		toggle.toggleClass('is-active');
    		$('.mobile-navigation').css('top', headerHeight + 100);
    		$('#mobile-nav-wrapper').css('height', windowHeight - headerHeight);
    		if(toggle.hasClass('is-active')) {
    			$('body,html,main').addClass('mobile-nav-is-active');
    			$('#mobile-nav-wrapper').addClass('is-active');
    		} else {
    			$('#mobile-nav-wrapper').removeClass('is-active');
    			$('body,html,main').removeClass('mobile-nav-is-active');
    		}
    	});
    	$('.mobile-navigation li.menu-item-has-children > a').on('click', function(event) {
    		event.preventDefault();
    		event.stopPropagation();
    		$(this).parent('li').toggleClass('is-active');
    	});
    }
    initMobileNav();

    // add ids to flexible content
    let addIdstoFcls = function() {
    	$('main .fcl').each(function(index) {
    		$(this).attr('id', 'section-'+index);
    	});
    }
    addIdstoFcls();

    // init slick slider
    let initSlider = function() {
		console.log('HELLO WORLD 1');
    	$('.hero-slider').slick({
    		'arrows': false,
			'dots': true,
			'infinite': true,
			'autoplay': false,
			'autoplaySpeed': 7500,
			'asNavFor': '.hero-expcert-slider',
    	});
    }
    initSlider();

    let intitMobileSlider = function() {
    	$('.hero-expcert-slider').slick({
    		'arrows' : false,
    		'dots' : false,
    		'infinite' : true,
    		'autoplay': false,
			'autoplaySpeed': 7500,
			'asNavFor': '.hero-slider',
			'adaptiveHeight' : true,
    	});
    }
    intitMobileSlider();

    // child toggle 
let initToggles = function() {
    if ($('.single-toggle-child-group').length > 0) {
        $('.single-toggle-group > h4').each(function() {
            let parentToggle = $(this);
            parentToggle.on('click', function() {
                parentToggle.closest('.single-toggle-group').toggleClass('active');
            });
        });
        $('.single-toggle-child-group > p').on('click', function(e) {
            e.stopPropagation(); // Stop the event from propagating to parent elements
            let childToggle = $(this);
            childToggle.closest('.single-toggle-child-group').toggleClass('active');
        });
    }
}
initToggles();


	$(window).on('load', function() {
	
	});

	var resizeTimer;

	$(window).on('resize', function(e) {

	  clearTimeout(resizeTimer);
	  resizeTimer = setTimeout(function() {

	    if($(window).width() > 991) {
	    	$('#mobile-nav-wrapper').removeClass('is-active');
    		$('body,html').removeClass('mobile-nav-is-active');
    		$('.mobile-nav-toggle').removeClass('is-active');
	    }
	            
	  }, 50);

	});




});